// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"181":"editMember","316":"sign_up","871":"important_message","885":"gift_manager","886":"sale_product","962":"home"}[chunkId] + "-legacy." + {"181":"98c817f5","316":"a76a2b48","871":"81eba932","885":"4b0b181f","886":"078e2139","962":"0d2589ed"}[chunkId] + ".js";
};